import { Logo } from "./Navbar";
import { scrollToId } from "../lib/scroll";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO } from "../lib/site";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-lec-bone/10 bg-lec-ink pb-24 text-lec-bone md:pb-0">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-5 py-14 md:flex-row md:items-end md:justify-between md:px-10">
      <div>
        <Logo className="h-14 rounded-md bg-white p-2" />
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-lec-bone/60">
          We believe in value, functionality, and sustainability. Family-owned decorative
          concrete, poured across the southern suburbs for over 25 years.
        </p>
      </div>
      <div className="flex flex-col gap-3 text-sm">
        <button
          data-testid="footer-quote-link"
          onClick={() => scrollToId("#quote")}
          className="text-left font-bold uppercase tracking-wider text-lec-green transition-colors hover:text-lec-bone"
        >
          Request a Quote
        </button>
        <a href={PHONE_TEL} data-testid="footer-phone-link" className="text-lec-bone/80 transition-colors hover:text-lec-green">
          {PHONE_DISPLAY}
        </a>
        <a href={EMAIL_MAILTO} data-testid="footer-email-link" className="text-lec-bone/80 transition-colors hover:text-lec-green">
          {EMAIL}
        </a>
      </div>
    </div>
    <div className="border-t border-lec-bone/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-lec-bone/40 md:flex-row md:items-center md:justify-between md:px-10">
        <p>© {new Date().getFullYear()} Leading Edge Concrete. All rights reserved.</p>
        <p>Exposed Aggregate · Honed · Liquid Limestone · Coloured — Perth WA</p>
      </div>
    </div>
  </footer>
);
